import { PersonProbationPeriodDueDateFragment } from "gql/graphql";
import { Hidable, Value } from "@/shared/value";

/**
 * Дата окончания испытательного срока — поле под защитой, поэтому показывается через
 * `Value`: он же разворачивает обёрнутую дату в штатный форматтер.
 */
export function PersonProbationPeriodDueDate({
  data,
}: {
  data?: Hidable<PersonProbationPeriodDueDateFragment>;
}) {
  return (
    <Value data={data}>
      {(person) => <Value data={person.probationPeriodDueDate} />}
    </Value>
  );
}
